export const frontmatter = {"title":"Customization Sender"};
export const toc = [];